export { default } from './TabsUnstyled';
export { default as TabsContext } from './TabsContext';
export * from './TabsContext';
export { default as tabsUnstyledClasses } from './tabsUnstyledClasses';
export * from './tabsUnstyledClasses';
export { default as useTabs } from './useTabs';
export * from './useTabs';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/base/TabsUnstyled/index.js
// module id = 96
// module chunks = 1